module.exports = __webpack_public_path__ + "img/pain_scale_video_trigger.70c9cd37.jpg";